// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────────────────
   Body font + smoothing now live in App.css (design system).
   This file is kept for create-react-app's expected import chain.
   ────────────────────────────────────────────────────────────────────── */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;2EAG2E","sourcesContent":["/* ──────────────────────────────────────────────────────────────────────\n   Body font + smoothing now live in App.css (design system).\n   This file is kept for create-react-app's expected import chain.\n   ────────────────────────────────────────────────────────────────────── */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
